function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(t, e) {
  if (e && ("object" == _typeof(e) || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t);
}
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, _getPrototypeOf(t);
}
function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && _setPrototypeOf(t, e);
}
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}
var MigrationMain = require('../main');
var ApeBondMainTemplate = require('./main.template');
var ApeBondMain = /*#__PURE__*/function (_MigrationMain) {
  function ApeBondMain(app, mod) {
    var _this;
    _classCallCheck(this, ApeBondMain);
    _this = _callSuper(this, ApeBondMain, [app, mod]);
    _this.treasury_error = '';
    _this.intents = {};
    return _this;
  }
  _inherits(ApeBondMain, _MigrationMain);
  return _createClass(ApeBondMain, [{
    key: "isActive",
    value: function isActive() {
      var _this$mod$urlpath;
      if (!this.app.BROWSER) {
        return false;
      }
      return ((_this$mod$urlpath = this.mod.urlpath) === null || _this$mod$urlpath === void 0 || (_this$mod$urlpath = _this$mod$urlpath[2]) === null || _this$mod$urlpath === void 0 ? void 0 : _this$mod$urlpath.toLowerCase()) === 'apebond';
    }
  }, {
    key: "render",
    value: function () {
      var _render = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              if (document.querySelector('.main')) {
                this.app.browser.replaceElementBySelector(ApeBondMainTemplate(this.mod, this.treasury_error), '.main');
              } else {
                this.app.browser.addElementToDom(ApeBondMainTemplate(this.mod, this.treasury_error));
              }
              this.attachEvents();
            case 1:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function render() {
        return _render.apply(this, arguments);
      }
      return render;
    }()
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      var _this2 = this;
      var migrate_button = document.getElementById('apebond-migrate');
      if (!migrate_button) {
        return;
      }
      migrate_button.onclick = function () {
        var _document$getElementB;
        var email = ((_document$getElementB = document.getElementById('apebond-email')) === null || _document$getElementB === void 0 || (_document$getElementB = _document$getElementB.value) === null || _document$getElementB === void 0 ? void 0 : _document$getElementB.trim()) || '';
        var normalized_email = _this2.normalizeEmail(email);
        if (email && !normalized_email) {
          salert('Please enter a valid email address or leave the email field empty.');
          return;
        }
        _this2.startAutomatedMigration({
          migration_type: 'apebond',
          email: normalized_email
        });
      };
    }
  }, {
    key: "normalizeEmail",
    value: function normalizeEmail() {
      var email = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var normalized_email = String(email).trim();
      if (!normalized_email) {
        return '';
      }
      if (normalized_email.length > 254 || /[\r\n]/.test(normalized_email)) {
        return '';
      }
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(normalized_email) ? normalized_email : '';
    }
  }, {
    key: "isApeBondPayment",
    value: function isApeBondPayment(payment) {
      return (payment === null || payment === void 0 ? void 0 : payment.migration_type) === 'apebond';
    }
  }, {
    key: "escapeHTML",
    value: function escapeHTML() {
      var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      return String(value).replaceAll('&', '&amp;').replaceAll('<', '&lt;').replaceAll('>', '&gt;').replaceAll('"', '&quot;').replaceAll(String.fromCharCode(39), '&#039;');
    }
  }, {
    key: "returnTeamEmailHTML",
    value: function returnTeamEmailHTML(payment) {
      if (!this.isApeBondPayment(payment)) {
        return '';
      }
      var unvalidated_address = String((payment === null || payment === void 0 ? void 0 : payment.mixin) || '').split('|')[0];
      var address = /^0x[a-fA-F0-9]{40}$/.test(unvalidated_address) ? unvalidated_address : '';
      var address_html = address ? "<a href=\"https://etherscan.io/address/".concat(address, "\">").concat(this.escapeHTML(address), "</a>") : this.escapeHTML(unvalidated_address || 'Unavailable');
      return "\n      <hr>\n      <h2>APE BOND REVIEW REQUIRED</h2>\n      <p>Confirm the origin of this ERC20 SAITO on Etherscan before manually paying the Ape Bond bonus.</p>\n      <p>FROM ERC20 ADDRESS: ".concat(address_html, "</p>\n      <p>USER EMAIL: ").concat(this.escapeHTML(payment.email || 'Not provided'), "</p>\n      <p>After paying the bonus, notify the user manually if an email address was provided.</p>\n    ");
    }
  }, {
    key: "sendUserMigrationConfirmation",
    value: function sendUserMigrationConfirmation(payment) {
      if (!this.isApeBondPayment(payment) || !payment.email) {
        return;
      }
      var amount = this.app.wallet.convertNolanToSaito(payment.nolan_received);
      var formatted_amount = this.app.browser.formatDecimals(amount, true);
      this.app.connection.emit('mailrelay-send-email', {
        to: payment.email,
        from: 'Saito Token Migration <info@saito.tech>',
        subject: 'Your Saito Ape Bond Migration is Complete',
        html: "\n        <div>\n          <p>Dear Saitozen,</p>\n          <p>".concat(this.escapeHTML(formatted_amount), " ERC20 SAITO has been migrated to mainnet SAITO.</p>\n          <p>Receiving Saito address: ").concat(this.escapeHTML(payment.public_key), "</p>\n          <p>Your Ape Bond bonus will be paid after the origin of the ERC20 SAITO is confirmed.</p>\n          <p>You will be alerted again once the bonus is paid.</p>\n          <p>Welcome to the Saitoverse!</p>\n          <p>-- The Saito Team</p>\n        </div>\n      "),
        ishtml: true
      });
    }
  }]);
}(MigrationMain);
module.exports = ApeBondMain;